import { alert } from './component/alert.listener.analytics';
import { routeListenerAnalytics } from './component/route.listener.analytics';
import { addToCartAnalytics } from './component/add-to-cart.listener.analytics';
import { dataSources } from './component/data-sources.listener.analytics';
import { aisleBay } from './component/aisle-bay.listener.analytics';
import { augmentedReality } from './component/augmented-reality.listener.analytics';
import { buybox } from './component/buybox.listener.analytics';
import { calculator } from './component/calculator.listener.analytics';
import { fbt } from './component/fbt.listener.analytics';
import { cardMessaging } from './component/card-messaging.listener.analytics';
import { catalogPromo } from './component/catalog-promo.listener.analytics';
import { categoryList } from './component/category-list.listener.analytics';
import { collectionList } from './component/collection-list.listener.analytics';
import { deliveryOptions } from './component/delivery-options.listener.analytics';
import { fbr } from './component/fbr.listener.analytics';
import { filtersAndRefinements } from './component/filter-refinements.listener.analytics';
import { fulfillment } from './component/fulfillment.listener.analytics';
import { sortRefinements } from './component/sort-refinement.analytics';
import { irg } from './component/irg.listener.analytics';
import { layoutManager } from './component/layout-manager.analytics';
import { errorBoundary } from './component/error-boundary.listener.analytics';
import { mediaGallery } from './component/media-gallery.listener.analytics';
import { trackOOS } from './component/track-out-of-stock.listener.analytics';
import { orderSample } from './component/order-sample.listener.analytics';
import { packagesMini } from './component/packages-mini.listener.analytics';
import { pagination } from './component/pagination.listener.analytics';
import { price } from './component/price.listener.analytics';
import { productDetails } from './component/product-details.listener.analytics';
import { productOverview } from './component/product-overview.listener.analytics';
import { productResults } from './component/product-results.listener.analytics';
import { superSku } from './component/super-sku.listener.analytics';
import { promotion } from './component/promotion.listener.analytics';
import { sharebelt } from './component/sharebelt.listener.analytics';
import { tabs } from './component/tabs.listener.analytics';
import { visualCategoryNav } from './component/visual-category-nav.listener.analytics';
import { stickyNav } from './component/sticky-nav.listener.analytics';
import { stashEvent } from './component/stash-event.listener';
import { page } from './experience/page';
import { ddoReady } from './component/digital-data.listener.analytics';
import { ratingsReviews } from './component/ratings-reviews';
import { instantCheckout } from './component/instant-checkout.listener.analytics';
import { productPod } from './component/product-pod.listener.analytics';
import { quiz } from './component/quiz.listener.analytics';
import { questionsAndAnswers } from './component/questions-and-answers.listener.analytics';
import { sizeGuide } from './component/size-guide.listener.analytics';
import { specialBuyPromos } from './component/special-buy-promos.listener.analytics';
import { relatedSearch } from './component/related-search.listener.analytics';
import { promotionProducts } from './component/promotion-products.listener.analytics';
import { productHotspots } from './component/product-hotspots.listener.analytics';
import { checkAvailability } from './component/check-availability.listener.analytics';
import { leadGeneration, articlesLeadGen } from './component/lead-generation.listener.analytics';
import { rentalIntent } from './component/rental-intent.listener.analytics';
import { rentalReservationForm } from './component/rental-reservation-form.listener.analytics';
import { dualPath } from './component/product-add-ons.listener.analytics';
import { seoExperience } from './experience/pages/seo-experience/seo-experience';
import { optOut } from './experience/pages/optOut/optOut';
import { addToQuote } from './component/add-to-quote.listener.analytics';
import { buyItAgain } from './component/buy-it-again.listener.analytics';
import { carPicker } from './component/car-picker.listener.analytics';
import { homeServicesCollection } from './component/collection-home-service.analytics';
import { swapitem } from './component/swap-item.listener.analytics';
import { videoPlayer } from './component/video-player.listener.analytics';
import { shopByRoom } from './experience/pages/shopByRoom/shopByRoom';
import { movingCalculator } from './component/moving-calculator.listener.analytics';
import { storePod } from './component/store-pod.listener.analytics';
import { storeSearch } from './component/store-search.listener.analytics';
import { endcap } from './component/endcap.listener.analytics';
import { articleGuides } from './component/article-guides.listener.analytics';
import { quickView } from './component/quick-view.listener.analytics';
import { impressionProvider } from './component/impression-provider.listener.analytics';
import { saveToFavoritesAnalytics } from './component/save-to-favorites.listener.analytics';
import { productSpecifications } from './component/product-specifications.listener.analytics';
import { listForms } from './component/list-forms.listener.analytics';
import { productList } from './component/product-list.listener.analytics';
import { supplementalRecs } from './component/supplemental-recs.listener.analytics';
import { recentPurchases } from './component/recent-purchases.listener.analytics';
import { marketingContent } from './component/marketing-content.listener.analytics';
import { productPodComposable } from './component/product-pod.composable.listener.analytics';
import { trendingCategories } from './component/trending-categories.listener.analytics';
import { topCategories } from './component/top-categories.listener.analytics';
import { productPodGroup } from './component/product-pod-group.listener.analytics';
import { instantRecs } from './component/instant-recs.listener.analytics';
import { toolsMaterials } from './component/tools-materials.listener.analytics';
import { userListsCarousel } from './component/user-lists-carousel.listener.analytics';
import { cartItem } from './component/cart-item.listener.analytics';
import { bathRenovation } from './component/bath-renovation.listener.analytics';
import { paymentMethodCard } from './component/payment-method-card.listener.analytics';
import { shippingAddressCard } from './component/shipping-address-card.listener.analytics';

const ThdAnalytics = {
  init: () => {
    if (typeof window === 'undefined') return;

    if (!window.THD_EVENT_BUS) {
      window.THD_EVENT_BUS = window.LIFE_CYCLE_EVENT_BUS;
    }

    try {
      seoExperience();
      page();
      routeListenerAnalytics();
      dataSources();
      ddoReady();
      addToCartAnalytics();
      aisleBay();
      alert();
      buybox();
      augmentedReality();
      calculator();
      cardMessaging();
      catalogPromo();
      categoryList();
      collectionList();
      deliveryOptions();
      fbr();
      fbt();
      fulfillment();
      irg();
      layoutManager();
      errorBoundary();
      sortRefinements();
      filtersAndRefinements();
      mediaGallery();
      orderSample();
      pagination();
      price();
      productDetails();
      productHotspots();
      productOverview();
      productResults();
      promotion();
      rentalIntent();
      rentalReservationForm();
      stickyNav();
      superSku();
      trackOOS();
      sharebelt();
      tabs();
      visualCategoryNav();
      stashEvent();
      ratingsReviews();
      relatedSearch();
      instantCheckout();
      productPod();
      quiz();
      questionsAndAnswers();
      sizeGuide();
      promotionProducts();
      checkAvailability();
      leadGeneration();
      articlesLeadGen();
      dualPath();
      optOut();
      addToQuote();
      buyItAgain();
      carPicker();
      homeServicesCollection();
      swapitem();
      specialBuyPromos();
      videoPlayer();
      shopByRoom();
      movingCalculator();
      storePod();
      storeSearch();
      endcap();
      articleGuides();
      quickView();
      impressionProvider();
      saveToFavoritesAnalytics();
      productSpecifications();
      listForms();
      productList();
      supplementalRecs();
      recentPurchases();
      packagesMini();
      marketingContent();
      productPodComposable();
      trendingCategories();
      topCategories();
      productPodGroup();
      instantRecs();
      toolsMaterials();
      userListsCarousel();
      cartItem();
      bathRenovation();
      paymentMethodCard();
      shippingAddressCard();
    } catch (err) {
      console.log(err);
    }

  }
};
export { ThdAnalytics };
